import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../api";
import {
  VIRTUAL_LOCKER_ADD_ITEM,
  VIRTUAL_LOCKER_ADD_ITEM_FAIL,
  VIRTUAL_LOCKER_ADD_ITEM_SUCCESS,
  VIRTUAL_LOCKER_DELETE_ITEM,
  VIRTUAL_LOCKER_DELETE_ITEM_FAIL,
  VIRTUAL_LOCKER_DELETE_ITEM_SUCCESS,
  VIRTUAL_LOCKER_GET_ITEM,
  VIRTUAL_LOCKER_GET_ITEM_BY_ID,
  VIRTUAL_LOCKER_GET_ITEM_BY_ID_FAIL,
  VIRTUAL_LOCKER_GET_ITEM_BY_ID_SUCCESS,
  VIRTUAL_LOCKER_UPDATE_ITEM,
  VIRTUAL_LOCKER_UPDATE_ITEM_FAIL,
  VIRTUAL_LOCKER_UPDATE_ITEM_SUCCESS,
  VIRTUAL_LOCKER_GET_ITEM_FAIL,
  VIRTUAL_LOCKER_GET_ITEM_SUCCESS,
  VIRTUAL_LOCKER_ITEM_STATUS_CHANGE,
  VIRTUAL_LOCKER_ITEM_STATUS_CHANGE_FAIL,
  VIRTUAL_LOCKER_ITEM_STATUS_CHANGE_SUCCESS,
} from "../actions/VirtualLockerAction";

function* virtualAdd(action) {
  try {
    const { onSuccess, ...otherPayload } = action.payload;
    const response = yield call(API.virtualAdd, otherPayload);
    if (typeof onSuccess === "function") {
      onSuccess();
    }
    yield put({
      type: VIRTUAL_LOCKER_ADD_ITEM_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: VIRTUAL_LOCKER_ADD_ITEM_FAIL,
      payload: { error: error },
    });
  }
}

function* virtualGetList(action) {
  try {
    const response = yield call(API.virtualGet, action.payload);

    yield put({
      type: VIRTUAL_LOCKER_GET_ITEM_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: VIRTUAL_LOCKER_GET_ITEM_FAIL,
      payload: { error: error },
    });
  }
}

function* virtualItemStatusChange(action) {
  try {
    const { onSuccess, onError, id, ...body } = action.payload;
    const response = yield call(API.virtualItemStatusChange, { id, ...body });
    if (typeof onSuccess === "function") {
      onSuccess();
    }
    yield put({
      type: VIRTUAL_LOCKER_ITEM_STATUS_CHANGE_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    if (typeof action.payload?.onError === "function") {
      action.payload.onError();
    }
    yield put({
      type: VIRTUAL_LOCKER_ITEM_STATUS_CHANGE_FAIL,
      payload: { error: error },
    });
  }
}

function* virtualDeleteItem(action) {
  try {
    const { onSuccess, ...otherPayload } = action.payload;
    yield call(API.virtualDelete, otherPayload);
    if (typeof onSuccess === "function") onSuccess();
    yield put({ type: VIRTUAL_LOCKER_DELETE_ITEM_SUCCESS, payload: otherPayload.id });
  } catch (error) {
    yield put({ type: VIRTUAL_LOCKER_DELETE_ITEM_FAIL, payload: { error } });
  }
}

function* virtualGetById(action) {
  try {
    const { isAdmin, isShopper, ...payload } = action.payload;
    const response = yield call(
      isAdmin ? API.getItemById : (isShopper ? API.personalShopperGetById : API.virtualGetById),
      payload
    );
    yield put({
      type: VIRTUAL_LOCKER_GET_ITEM_BY_ID_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: VIRTUAL_LOCKER_GET_ITEM_BY_ID_FAIL,
      payload: { error },
    });
  }
}

function* virtualUpdateItem(action) {
  try {
    const { onSuccess, ...otherPayload } = action.payload;
    const response = yield call(API.virtualUpdateItem, otherPayload);
    if (typeof onSuccess === "function") onSuccess();
    yield put({ type: VIRTUAL_LOCKER_UPDATE_ITEM_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: VIRTUAL_LOCKER_UPDATE_ITEM_FAIL, payload: { error } });
  }
}

function* virtualLockerSaga() {
  yield takeLatest(VIRTUAL_LOCKER_ADD_ITEM, virtualAdd);
  yield takeLatest(VIRTUAL_LOCKER_GET_ITEM, virtualGetList);
  yield takeLatest(VIRTUAL_LOCKER_GET_ITEM_BY_ID, virtualGetById);
  yield takeLatest(VIRTUAL_LOCKER_ITEM_STATUS_CHANGE, virtualItemStatusChange);
  yield takeLatest(VIRTUAL_LOCKER_UPDATE_ITEM, virtualUpdateItem);
  yield takeLatest(VIRTUAL_LOCKER_DELETE_ITEM, virtualDeleteItem);
}
export default virtualLockerSaga;
